import { attr, customElement, FASTElement, observable } from '@microsoft/fast-element';
import { ProjectVppaCardTemplate as template } from './project-vppa-card.template';
import { ProjectVppaCardStyles as styles } from './project-vppa-card.styles';
import { IAllProjects } from '../../../types';
import { ZeroGridPro as zeroAgGrid } from '@genesislcap/foundation-zero-grid-pro';
import { ICompanyService } from '../../../services/company.service';
import { IIndividualProjectPageService } from '../../../services/individual-project-page.service';
import { Auth } from '@genesislcap/foundation-comms';
import { getHtmlIconByName, getTechnologyIconName } from '../../../styles';
import { getFillColorFromProjectStatus } from '../../../utils/formatting';

const name = 'project-vppa-card';

@customElement({
  name,
  template,
  styles,
})
export class ProjectVppaCard extends FASTElement {
  @Auth auth: Auth;
  @ICompanyService companyService: ICompanyService;
  @IIndividualProjectPageService individualProjectPageService: IIndividualProjectPageService;
  @attr @observable isSelected: boolean;
  @attr @observable project: IAllProjects;
  @attr @observable isDraftProject: boolean = false;
  @attr @observable company: string;

  @observable gridVisibility: boolean = false;
  @observable numberOfRows: number = 0;
  @observable gridHeight: string = '34px';
  @observable vppaGrid: zeroAgGrid;

  connectedCallBack() {
    super.connectedCallback();
    const gridOptions = {
      groupRowRendererParams: {
        checkbox: true,
        suppressCount: true,
      },
      animateRows: true,
      groupSelectsChildren: true,
      suppressRowClickSelection: true,
      suppressBrowserResizeObserver: true,
      scrollbarWidth: 10,
      rowClass: 'transparent-background',
    };

    this.vppaGrid.gridOptions = gridOptions;
  }

  rowSelection(row) {
    if (row.data?.VPPA_ID) {
      if (!this.isSelected) {
        this.$emit('selectedProject', this.project);
      }

      this.$emit('vppaRowSelected', row.data?.VPPA_ID);
    }
  }

  public openProjectPage() {
    this.individualProjectPageService.openIndividualProjectPage(this.project.PROJECT_ID);
  }

  public projectSelected() {
    this.$emit('selectedProject', this.project);
  }

  public switchGridVisibility() {
    this.gridVisibility = !this.gridVisibility;
  }

  public onGridReady() {
    this.vppaGrid.gridApi.addEventListener('rowClicked', (row) => this.rowSelection(row));
  }

  public customEvents = {
    onRowDataUpdated: () => {
      const rowCount = this.vppaGrid.gridApi.getDisplayedRowCount();
      if (rowCount) {
        this.numberOfRows = rowCount;
        const gridHeightAux = 32.5 * this.numberOfRows + 34;
        this.gridHeight = gridHeightAux + 'px';
        return;
      }
      this.numberOfRows = 0;
    },
  };

  public getTechnologyIcon() {
    return getHtmlIconByName({
      name: getTechnologyIconName(this.project?.TECHNOLOGY),
      slot: 'start',
      width: '20px',
      height: '20px',
      fill: getFillColorFromProjectStatus(this.project?.PROJECT_OPERATIONAL_STATUS),
    });
  }
}
